module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Portes Services s.a.","short_name":"Portes Services","start_url":"/","background_color":"#edf2f7","theme_color":"#edf2f7","display":"minimal-ui","icon":"src/images/favicon.png","lang":"fr","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"ad3f976181005c7f9d515d47be24301d"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
